export const EXCMDAILYPLAN_SHOW_RESET = 'EXCMDAILYPLAN_SHOW_RESET'
export const EXCMDAILYPLAN_SHOW_SET_ERROR = 'EXCMDAILYPLAN_SHOW_SET_ERROR'
export const EXCMDAILYPLAN_SHOW_SET_RETRIEVED = 'EXCMDAILYPLAN_SHOW_SET_RETRIEVED'
export const EXCMDAILYPLAN_SHOW_TOGGLE_LOADING = 'EXCMDAILYPLAN_SHOW_TOGGLE_LOADING'
